import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../../utils/http";
import { TableFilterParams } from "../util/types";
const BaseURL = process.env.REACT_APP_API_URL;

export const fetchCustomerOrderAction = createAsyncThunk(
  "fetch-customer-order",
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await http.get({
        url: `${BaseURL}/organisation-portal/find-customer-order/${id}`,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
    }
  }
);

export const fecthCustomerResult = createAsyncThunk(
  "fetch-customer-result",
  async (payload: { voucherCode: string }, { rejectWithValue }) => {
    try {
      const res = await http.get({
        url: `${BaseURL}/voucher/find-by-code/${payload.voucherCode}`,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
    }
  }
);

export const fetchFilteredOrganisationOrdersAction = createAsyncThunk(
  "fetch_filtered_organisation_orders",
  async (filterParams: TableFilterParams, { rejectWithValue }) => {
    try {
      const { organisationId, page, rows, filters } = filterParams;
      const resp = await http.get({
        url: `${BaseURL}/organisation-portal/find-filtered-organisation-orders/${organisationId}`,
        query: {
          page,
          rows,
          searchString: filters?.global?.value,
        },
      });

      return resp;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

